namespace orderEnum {
  export enum Status {
    Created = 'Created',
    Paid = 'Paid',
    Assigned = 'Assigned',
    InProgress = 'InProgress',
    Canceled = 'Canceled',
    Done = 'Done'
  }
}

export default orderEnum;
